export class RequestStatus {
    ID: number;
    Name: string;
}

export default RequestStatus;